import React from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import Img from '../../assets/images/Sinh_Trac_1.png';
import {motion} from 'framer-motion';
import {useNavigate} from 'react-router-dom';
import {BackButton} from '../../components/BackButton';

const Biometric = () => {
  const navigate = useNavigate ();

  const onClick = () => {
    navigate ('tablet');
  };
  return (
    <AnimatedPage animationType="fade">
      <div
        style={{
         width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BackButton />
        <motion.img
          src={Img}
          alt="Digibank"
          initial={{opacity: 0, scale: 0.8}}
          animate={{opacity: 1, scale: 1}}
          transition={{delay: 0.1, duration: 0.5, ease: 'easeOut'}}
          style={{
            width: '90%',
            height: '90%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
        <div
          onClick={onClick}
          style={{
            position: 'absolute',
            top: `calc(1250 / 2160 * 100vh)`,
            left: `calc(1300 / 4096 * 100vw)`,
            width: `calc(360 / 4096 * 100vw)`,
            height: `calc(360 / 4096 * 100vw)`,
          }}
        />
      </div>
    </AnimatedPage>
  );
};

export default Biometric;
